import { Component, OnInit } from '@angular/core';
import { AlertsService } from 'app/services/system/alerts/alerts.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
    alertHidden: boolean;
    alertShow: boolean;
    alertSuccessShowDisplayNone: boolean = true;
    alertHeader: string;
    alertSuccessShow: boolean;
    alertSuccessMessage: string;
    alertInfoShow: boolean;
    alertInfoMessage: string;
    alertInfoHeader: string;
    alertErrorShow: boolean;
    alertErrorShowDisplayNone: boolean = true;
    alertInfoShowDisplayNone: boolean = true;
    alertErrorMessage: string;
    alertFooter: string;
    alertMessage: string;
    alertShowIcon: boolean;

    constructor(private alertsService: AlertsService) {
        this.alertsService.alertHeader.subscribe((alertHeader) => (this.alertHeader = alertHeader));
        this.alertsService.alertMessage.subscribe((alertMessage) => (this.alertMessage = alertMessage));
        this.alertsService.alertFooter.subscribe((alertFooter) => (this.alertFooter = alertFooter));
        this.alertsService.alertShowIcon.subscribe((alertShowIcon) => (this.alertShowIcon = alertShowIcon));
        this.alertsService.alertShow.subscribe((alertShow) => {
            this.onChangeEvent();
            this.alertShow = alertShow;
        });
        this.onScrollEvent();
        this.alertsService.alertHidden.subscribe((alertHidden) => {
            this.alertHidden = alertHidden;
            this.onChangeEvent();
        });

        const self = this;
        // Passar að henda út alert í DOM
        setTimeout(function () {
            self.alertsService.alertSuccessShow.subscribe((alertSuccessShow) => {
                self.alertSuccessShow = alertSuccessShow;
                if (!alertSuccessShow) {
                    setTimeout(function () {
                        self.alertSuccessShowDisplayNone = true;
                    }, 500);
                } else {
                    self.alertSuccessShowDisplayNone = false;
                }
            });
        }, 50);

        setTimeout(function () {
            self.alertsService.alertInfoShow.subscribe((alertInfoShow) => {
                self.alertInfoShow = alertInfoShow;
                if (!alertInfoShow) {
                    setTimeout(function () {
                        self.alertInfoShowDisplayNone = true;
                    }, 500);
                } else {
                    self.alertInfoShowDisplayNone = false;
                }
            });
        }, 50);

        this.alertsService.alertInfoHeader.subscribe((alertInfoHeader) => (this.alertInfoHeader = alertInfoHeader));
        this.alertsService.alertInfoMessage.subscribe((alertInfoMessage) => (this.alertInfoMessage = alertInfoMessage));
        this.alertsService.alertSuccessMessage.subscribe((alertSuccessMessage) => (this.alertSuccessMessage = alertSuccessMessage));

        // Passar að henda út alert í DOM
        setTimeout(function () {
            self.alertsService.alertErrorShow.subscribe((alertErrorShow) => {
                self.alertErrorShow = alertErrorShow;
                if (!alertErrorShow) {
                    setTimeout(function () {
                        self.alertErrorShowDisplayNone = true;
                    }, 500);
                } else {
                    self.alertErrorShowDisplayNone = false;
                }
            });
        }, 50);

        this.alertsService.alertErrorMessage.subscribe((alertErrorMessage) => (this.alertErrorMessage = alertErrorMessage));
    }

    onChangeEvent() {
        let self = this;
        setTimeout(function () {
            self.checkScrollPosition();
        }, 100);
    }

    onScrollEvent() {
        let self = this;
        try {
            window.onscroll = function (e) {
                self.checkScrollPosition();
            };
        } catch {}
    }

    checkScrollPosition() {
        try {
            var bodyAlert = document.getElementById('bodyAlert');
            if (bodyAlert != null) {
                if (window.scrollY > 20) {
                    bodyAlert.classList.add('scrolledPosition');
                } else {
                    bodyAlert.classList.remove('scrolledPosition');
                }
            }
        } catch {}
    }

    ngOnInit() {}

    closealertAlert() {
        this.alertsService.changealertShow(false);
    }
}
